'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';

/** Current location hash (e.g. `#how`) for marketing nav active states on `/`. */
export function useMarketingNavHash() {
  const $ = _c(2);
  const [hash, setHash] = useState("");
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const sync = () => setHash(window.location.hash);
      sync();
      window.addEventListener("hashchange", sync);
      return () => window.removeEventListener("hashchange", sync);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return hash;
}